module.exports = __webpack_public_path__ + "static/media/noavatar.63f1cebb.svg";